import React from 'react';
import './AgeGate.css';

const AgeGate = () => {
  const handleAgeConfirm = (isAdult) => {
    if (isAdult) {
      localStorage.setItem('ageVerified', 'true');
      localStorage.setItem('ageVerifiedTime', Date.now().toString());
      window.location.reload();
    } else {
      // User is under 18
      alert('Sorry, you must be 18 or older to access this site.');
    }
  };

  return (
    <div className="page-container">
      <div className="age-gate-card">
        <div className="age-gate-header">
          <h1 className="age-gate-title">Carnivores Adapting Terribly</h1>
          <div className="warning-icon">⚠️</div>
        </div>

        <div className="age-gate-content">
          <h2 className="age-gate-question">Are you 18 years or older?</h2>

          <div className="age-gate-warning">
            <p>
              <strong>This game contains mature content including:</strong>
            </p>
            <ul>
              <li>Adult humor and language</li>
              <li>Politically incorrect themes</li>
              <li>Content that may be offensive</li>
            </ul>
            <p className="age-gate-disclaimer">
              By entering, you confirm that you are at least 18 years of age and understand that you
              may encounter content you find offensive.
            </p>
          </div>

          <div className="age-gate-buttons">
            <button
              onClick={() => handleAgeConfirm(true)}
              className="btn btn-confirm"
              aria-label="I am 18 or older"
            >
              Yes, I'm 18+
            </button>
            <button
              onClick={() => handleAgeConfirm(false)}
              className="btn btn-decline"
              aria-label="I am under 18"
            >
              No, I'm under 18
            </button>
          </div>
        </div>

        <div className="age-gate-footer-text">
          <p>
            By clicking "Yes, I'm 18+", you agree to our{' '}
            <a href="/terms" className="age-gate-link">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="/privacy" className="age-gate-link">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
